import { KEY_NOTES_PANEL_WIDTH, KEY_NOTES_SELECTED_DOCUMENT } from "../../../../common/providers/keys/keys";

class NotesProvider {
	constructor() {
		this.sessionStorage = window.sessionStorage;
		this.localStorage = window.localStorage;
	}

	setSelectedDocument(payload) {
		return this.sessionStorage.setItem(KEY_NOTES_SELECTED_DOCUMENT, JSON.stringify(payload));
	}

	getSelectedDocument() {
		return JSON.parse(this.sessionStorage.getItem(KEY_NOTES_SELECTED_DOCUMENT));
	}

	setNotesPanelWidth(width) {
		return this.localStorage.setItem(KEY_NOTES_PANEL_WIDTH, width);
	}

	getNotesPanelWidth() {
		return JSON.parse(this.localStorage.getItem(KEY_NOTES_PANEL_WIDTH));
	}
}
export default new NotesProvider();
